import { useRef, memo } from 'react';
import { attachWrappedComponent } from '../ScrollingColumn/ShareScrollElement';

// The MemoExoticComponent type does not allow propTypes or defaultProps
// but we rely on that in several button components.
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This is an internal HOC that should not be exported to consumers.
 */
export default function (Component) {
  const ShareButtonComponent = /*#__PURE__*/memo(props => {
    const defaultRef = useRef(null);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      buttonRef: props.buttonRef || defaultRef
    }));
  });
  attachWrappedComponent(ShareButtonComponent, Component);
  return ShareButtonComponent;
}